import axios, { AxiosInstance } from 'axios';
import { useContext } from 'react';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { attachAuthRetryInterceptor, AuthRetryRequestConfig } from '../utils/authRetry';

const useAxios = (): AxiosInstance => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);

    const instance = axios.create();

    instance.interceptors.request.use(config => {
        // A replayed request already carries the freshly refreshed token - don't overwrite
        // it with the (stale) token captured in this render's context
        if (!(config as AuthRetryRequestConfig).authRetried) {
            config.headers.Authorization = userContext.jwtToken || userContext.user?.signInUserSession?.accessToken?.jwtToken || '';
        }

        config.headers.apiKey = settingsContext.apiKey;

        return config;
    });

    attachAuthRetryInterceptor(instance, userContext.refreshToken);

    return instance;
};

export default useAxios;
